import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_carousel = _resolveComponent("carousel")!

  return (_openBlock(), _createBlock(_component_carousel, {
    class: "teasergroup_teaser__slider",
    "slides-count": _ctx.itemCount,
    options: _ctx.swiperOptions,
    "preload-slide-count": 1,
    "show-skip-slider-link": true
  }, _createSlots({ _: 2 /* DYNAMIC */ }, [
    _renderList(_ctx.$slots, (_, name) => {
      return {
        name: name,
        fn: _withCtx(() => [
          _renderSlot(_ctx.$slots, name)
        ])
      }
    })
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["slides-count", "options"]))
}